module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'charts/base' && templateVars.config ?
				templateVars.config :
				{
	"chartsWithTableLegend": [
		"#chart_example"
	]
};